import AnchorDefault from "../../../../../../packages/design-system/primitives/examples/constellation/anchor/default";
import AnchorStyled from "../../../../../../packages/design-system/primitives/examples/constellation/anchor/styled";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHanchorSLASHdefault from "!!raw-loader!../../../../../../packages/design-system/primitives/examples/constellation/anchor/default";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHanchorSLASHstyled from "!!raw-loader!../../../../../../packages/design-system/primitives/examples/constellation/anchor/styled";
import { CodeDocsHeader } from '@af/design-system-docs-ui';
import SectionMessage from '@atlaskit/section-message';
import * as React from 'react';
export default {
  AnchorDefault,
  AnchorStyled,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHanchorSLASHdefault,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHanchorSLASHstyled,
  CodeDocsHeader,
  SectionMessage,
  React
};